import { render, staticRenderFns } from "./ModalsContainer.vue?vue&type=template&id=32f8d4b6&"
import script from "./ModalsContainer.vue?vue&type=script&lang=js&"
export * from "./ModalsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ploi/www.continental-holdings.com/web/app/themes/chc-wp-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32f8d4b6')) {
      api.createRecord('32f8d4b6', component.options)
    } else {
      api.reload('32f8d4b6', component.options)
    }
    module.hot.accept("./ModalsContainer.vue?vue&type=template&id=32f8d4b6&", function () {
      api.rerender('32f8d4b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vendor/vue-js-modal/components/ModalsContainer.vue"
export default component.exports